import styled from 'styled-components';
import { ShadowBoxDark } from 'app/components';
import { textTransform } from 'utils';
import { withChevron } from 'app/theme';

export const BlockSnacksPlanInner = styled(ShadowBoxDark).attrs({
  className: 'b-snacks__inner'
})`

margin-bottom:80px;
// padding: 0 0 32px;
padding: 0 0 100px;
  .b-seatplan__btn-zoom-wrapper {
    padding: ${({ theme }) => `14px ${theme.indent.l} ${theme.indent.l}`};
    font-size: 0;
    text-align: right;
  }

  @media screen and (max-width: ${({ theme }) => theme.breakPoints.md.width}) {
    .b-seatplan__btn-zoom-wrapper {
      padding: ${({ theme }) => `0 ${theme.indent.m} 10px`};
    }
  }
`;

export const NavTabsWrapper = styled.div.attrs({
  className: 's-movies__nav-tabs'
})`
  min-width: 320px;
  background-color: ${({ theme }) => theme.color.bgPrimary};

  @media screen and (max-width: ${({ theme }) => theme.breakPoints.md.width}) {
    width: 100%;
    // position: fixed;
    z-index: 9;
    // top: ${({ theme }) => theme.breakPoints.sm.header};
    left: 0;
    min-width: 300px;
  }
`;

export const NavTabsListForSnacks = styled.ul.attrs({
  className: 'l-nav-tabs'
})`
  font-size: 0;
  text-align: center;
  box-shadow: 0 2px 4px 0 ${({ theme }) => theme.color.rgbaBlack('.2')};
  border-bottom: 1px solid ${({ theme }) => theme.color.borderDark};
  position: relative;

  &::before {
    content: '';
    // width: calc(100% + 10px);
    width: 100%;
    height: 100%;
    background-color: #242424;
    position: absolute;
    // left: -5px;
    left: 0;
    top: 0;
    border-top-right-radius:8px;
    border-top-left-radius:8px;
  }
`;

export const RewardListForSnacksDrinks = styled.div.attrs({
  className: 'reward-list'
})`
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  // column-gap: 16px;
  // row-gap: 16px;
  gap:32px;
  margin-top: 16px;
  padding: 0 16px;
  text-align :center;
  .reward-list__item {
    // width: 174px;
    width: 100%;
    height: 216px;
    padding: 16px;
    // background: #242424;
    background: #2B2B2B;
    box-shadow: 0px 3px 4px rgba(0, 0, 0, 0.104988);
    border-radius: 8px;

    &.inactive {
      opacity: 0.5;
    }
  }
  .reward-list__item__desktop{
    display:flex;
    justify-content:space-between;
    flex-direction:column;
    align-items:center;
    height:100%;
    // color:#FFFFFF66; // this should be apply when the item is not in stock.
  }
  .reward-list__item__content {
    // display: flex;
    // flex-direction: column;
    // align-items: center;
    height:100%;
    .rewardImage {
      height: 102px;
      // width: 102px;
      margin-bottom:12px;
    }
    h3 {
      // font-weight: 450;
      // font-size: 24px;
      // line-height: 24px;
      // margin-top: 8px;
      font-weight: 500;
      font-size: 18px;
      line-height: 24px;
      margin-top: 8px;
      text-align: center;
    }
    h4 {
      // font-weight: 420;
      // font-size: 12px;
      // line-height: 16px;
      // text-transform: ${textTransform};
      // margin-top: 8px;
      // color:#888888;
      font-weight: 500;
      font-size: 16px;
      line-height: 20px;
      text-transform: uppercase;
      margin-top: 8px;
      color: #888888
    }
  }
.snacks_inputField{
  // width: 174px;
  width: 100%;
  height: 38px;
  background-color: #2B2B2B;
  border-radius: 8px;
  margin: 10px 0px;
  text-align:center;
  padding:8px;  
  // color:#FFFFFF66; // this should be apply when the item is not in stock.
}
// .sub_input{
// display:flex;
// justify-content:center;
// padding:8px;
// }
.notInStock{
  width: 79px;
  height: 24px;
  border-radius: 4px;
  background-color: #888888;
  padding: 4px;
  position: absolute;
  top: 10px;
  left: 10px;
  opacity: 0;
  // opacity: 1; // to show not in stock box use this
}
.notInStock span{
  font-size: 12px;
  font-weight: 400;
}
  @media screen and (max-width: ${({ theme }) => theme.breakPoints.sm.width}) {
    grid-template-columns:repeat(2, 1fr);
    width: 100%;

    .reward-list__item {
      // width: auto;
      // min-height: 70px;
      // height: auto;
      padding: 11px 8px;

      .reward-list__item_mobile {
        // display: flex;
        // align-items: center;
        margin-bottom: 12px;
      }
     .reward-list__item_mobile_text {
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        height: 100%;        
        // color:#FFFFFF66; // this should be apply when the item is not in stock.
      }

      &.inactive {
        background: transparent;
      }
    }
    .reward-list__item__content {
      // flex-direction: row;
      // justify-content: space-between;
      display: flex;
      flex-direction: column;
      height: 100%;
      .rewardImage {
        height: 102px;
        // width: 102px;
        // margin-right: 10px;
      }
      h3 {
        margin-top: 0;
      }
      h4 {
        margin-top: 0;
        // margin-right: 10px;
        font-size:12px;
      }
    }
  }

  @media screen and (min-width: ${({ theme }) => theme.breakPoints.sm.width}) and (max-width: 1200px) {
    grid-template-columns: repeat(3, 1fr);

    .reward-list__item {
      width: auto;
      height: 216px;

      &.inactive {
        background: transparent;
      }
    }
  }
`;

export const ShowMoreWrapper = styled.div.attrs({
  className: 'show_more'
})`
  // min-width: 320px;
  // background-color: ${({ theme }) => theme.color.bgPrimary};
  text-align: center;
  margin-top: 48px;
.b-movie-description__btn{
  background-color: #2D2D2D;
  border: 1px solid #575757;
  min-width: 115px;
  // font: ${({ sm }) => (sm ? '500' : '700')} 1.4rem/1 Cabin, sans-serif;
  font: ${({ sm }) => (sm ? '500' : '500')} 1.4rem/1 'Open Sans', sans-serif;
  // text-transform: ${textTransform};
  color: ${({ theme }) => theme.color.textPrimary};
  border-radius: 2em;
  padding: ${({ sm }) => sm ? '0.43em 1.1em' : '0.645em 1.15em'};
}
//   // padding: 0.43em 1.4em;
//   // ${withChevron}

//   ._with-chevron {
//     // padding: 0;
//     position: relative;
//     cursor: pointer;
//     // margin:0 5px;
//     top: 0;
//     left: 0;
//     right: 0;
//     bottom: 0;
//     margin: auto;
//     &::after {
//       transform: rotate(135deg) translate(-0.1em, 0.05em);
//     }
//   }
//   &:hover {
//     &::before {
//       border-color: ${({ theme }) => theme.color.textPrimary};
//     }

//     ._with-chevron::after {
//       border-color: ${({ theme }) => theme.color.textPrimary};
//     }
//   }

// }
  @media screen and (max-width: ${({ theme }) => theme.breakPoints.md.width}) {
    // width: 100%;
    // // position: fixed;
    // z-index: 9;
    // // top: ${({ theme }) => theme.breakPoints.sm.header};
    // left: 0;
  }
`;
export const Chevron = styled.span`
  display: inline-block;
  position: relative;
  top: ${({ isRotated }) => (isRotated ? '0px' : '-3px')};
  left: 3px;
  width: 0.5em;
  height: 0.5em;
  margin-left:5px;
  border: solid ${({ theme }) => theme.color.textPrimary};
  border-width: 0 2px 2px 0;
  transform: ${({ isRotated }) => (isRotated ? 'rotate(225deg)' : 'rotate(400deg)')};
  transition: transform 0.3s ease;

  &:hover {
    border-color: ${({ theme }) => theme.color.textPrimary};
  }
`;